import { supabase } from '../supabaseClient';
import { mapFacility } from '../lib/helpers';

const toDb = (f) => {
  const row = {
    code:     f.code,
    name:     f.name,
    type:     f.type,
    location: f.location,
    status:   f.status,
    manager:  f.manager,
    contact:  f.contact,
    antennas: f.antennas,
    org_id:   f.org_id,
  };
  // Only include id if it already exists (for updates)
  if (f.id) row.id = f.id;
  return row;
};

export const facilitiesService = {

  async getAll() {
    const { data, error } = await supabase.from('facilities').select('*').order('name');
    if (error) throw error;
    return data.map(mapFacility);
  },

  async create(facility) {
    const { data, error } = await supabase
      .from('facilities')
      .insert([toDb(facility)])
      .select()
      .single();
    if (error) throw error;
    return mapFacility(data);
  },

  async update(id, changes) {
    const { data, error } = await supabase
      .from('facilities')
      .update(toDb(changes))
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return mapFacility(data);
  },

  async delete(id) {
    const { error } = await supabase.from('facilities').delete().eq('id', id);
    if (error) throw error;
  },

  // ── Antennas ────────────────────────────────────────────
  async getAntennas(facilityId) {
    const { data, error } = await supabase
      .from('antennas')
      .select('*')
      .eq('facility_id', facilityId)
      .order('id');
    if (error) throw error;
    return data;
  },

  async createAntenna(antenna) {
    const { data, error } = await supabase
      .from('antennas')
      .insert([{
        facility_id:   antenna.facility_id,
        facility_name: antenna.facility_name,
        location:      antenna.location,
        status:        antenna.status || 'Online',
      }])
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async deleteAntennasByFacility(facilityId) {
    const { error } = await supabase
      .from('antennas')
      .delete()
      .eq('facility_id', facilityId);
    if (error) throw error;
  },
};
